import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { ClockIcon } from 'lucide-react';
export function CountdownTimer() {
  const {
    minutes,
    seconds
  } = useCountdown();
  const TimeBlock = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-79">
      <div className="bg-white text-navy-900 rounded-lg px-4 py-3 min-w-[70px] shadow-lg" data-id="element-80">
        <span className="text-3xl font-bold" data-id="element-81">
          {String(value).padStart(2, '0')}
        </span>
      </div>
      <span className="text-xs text-gray-300 mt-2 uppercase tracking-wide" data-id="element-82">
        {label}
      </span>
    </div>;
  return <div className="bg-gradient-to-r from-red-600 to-pink-600 text-white py-6 px-4" data-id="element-83">
      <div className="max-w-4xl mx-auto" data-id="element-84">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-85">
          <div className="flex items-center gap-3" data-id="element-86">
            <ClockIcon className="w-8 h-8 animate-pulse" data-id="element-87" />
            <div className="text-left" data-id="element-88">
              <p className="text-sm font-semibold uppercase tracking-wide" data-id="element-89">
                Oferta Termina En:
              </p>
              <p className="text-xs text-gray-200" data-id="element-90">¡Solo quedan 5 minutos!</p>
            </div>
          </div>

          <div className="flex gap-3" data-id="element-91">
            <TimeBlock value={minutes} label="Minutos" data-id="element-92" />
            <div className="text-3xl font-bold self-center mb-6" data-id="element-93">:</div>
            <TimeBlock value={seconds} label="Segundos" data-id="element-94" />
          </div>
        </div>
      </div>
    </div>;
}